<template>
  <div class="referrals-history">
    <div class="dashboard-container">
      <div class="referral-info">
        <div class="left">
          <p>Referral earnings</p>
          <div class="amount"><span class="usd me-2">$</span>{{ $auth.user().earnings_referral|formatCents }}</div>
        </div>
        <div class="right">
          <p>Number of users referred</p>
          <div class="amount transaction-num">{{ referred }}</div>
        </div>
      </div>
      <div class="referrals box-style">
        <div class="referral" v-for="r in referrals" :key="r.id">
          <div class="referral-details d-flex align-items-center justify-content-between">
            <div class="status text-capitalize" :class="r.status">{{ r.status }}</div>
          </div>
          <div class="email" v-if="r.referral">{{ r.referral.email }}</div>
          <div class="referral-amount d-flex justify-content-between align-items-center">
            <div class="amount"><span>%</span>20 USD</div>
            <div class="value">{{ r.ip }}</div>
          </div>
        </div>
        <div class="text-center" v-if="referrals.length === 0"><h2>No referrals</h2></div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api"
const api = new API()

import {Referral} from "@/models"

export default {
  name: "Referrals",
  data() {
    return {

    }
  },
  mounted() {
    this.$wait.start('referrals_fetch')
    api.getReferrals()
      .then(r => Referral.insertOrUpdate({
          data: r.data.results
        }))
      .catch(e => console.log(e))
      .finally(() => this.$wait.end('referrals_fetch'))
  },
  computed: {
    referrals() {
      return Referral.all()
    },
    referred() {
      return Referral.query()
          .where('status','registered')
          .count()
    }
  }
}
</script>

<style scoped>
  .cancelled {
    background: #DE6969FF;
    color: #ffffff !important;
  }
</style>